<template lang="pug">
el-form-item(label-width="0")
  el-input.width-full(size="mini", v-model.trim="data.content")
</template>
<script>
import { baseMixin } from "./index.js";
export default {
  mixins: [baseMixin]
};
</script>
<style lang="scss" scoped src="./index.scss"></style>
